/* EF island model entry and same-session design continuity. No prices or cart writes. */
(function (window, document) {
  'use strict';
  if (window.EFIJourney) return;
  var MODELS = ['KS_77', 'KS_98', 'KS_119', 'KS_140'];
  var FINISHES = ['FrameFinishes', 'DoorFinishesGrill', 'TopFinishes'];
  var KEY = 'ef-island-design-v1:';
  var memory = Object.create(null), revisionCache = new WeakMap();
  var desired = null, loader = null, active = null, waiters = [], entered = false;
  var invalidEntry = false, captureTimer = null;
  function known(code) { return MODELS.indexOf(code) !== -1; }
  function studioHash(hash) { return ['#app', '#studio', '#configurator'].indexOf(hash) !== -1; }
  function url() { return new URL(window.location.href); }
  function cleanString(value, max) { return typeof value === 'string' && value.length <= max; }
  function isRecord(value) { return value && typeof value === 'object' && !Array.isArray(value); }
  function codeOf(instance) { return instance && instance.opts && instance.opts.data && instance.opts.data.code; }
  function byId(id) { return document.getElementById(id); }
  function setMode(mode) {
    document.documentElement.setAttribute('data-efi-mode', mode);
    var hub = byId('efiShowroomHub');
    if (hub) hub.hidden = mode === 'studio';
  }
  function message(text, instance, review) {
    var id = instance ? 'efiStudioMessage' : 'efiHubMessage';
    var node = byId(id);
    if (!node) {
      node = document.createElement('div'); node.id = id;
      node.className = 'efi-journey-message'; node.setAttribute('role', 'status');
      var parent = instance ? byId('app') : byId('efiShowroomHub');
      if (!parent) return;
      if (instance) parent.parentNode.insertBefore(node, parent);
      else parent.insertBefore(node, parent.firstChild);
    }
    node.replaceChildren(); node.hidden = !text;
    if (!text) return;
    var copy = document.createElement('p'); copy.textContent = text; node.appendChild(copy);
    if (review && instance) {
      var button = document.createElement('button'); button.type = 'button';
      button.className = 'ef-b ef-b--ghost'; button.textContent = 'Review current selections';
      button.addEventListener('click', function () {
        if (active !== instance) return;
        if (instance.showTab) instance.showTab('ch-review');
        instance._efiNeedsReview = false;
        save(instance); message('', instance);
      });
      node.appendChild(button);
    }
  }
  function engineDefaults() {
    if (document.documentElement.getAttribute('data-efi-mode') !== 'studio') return;
    var defaults = { efpt: 'live', efhq: '1', efwow: '1', efquality: 'photoreal', efdpr: '2', efms: '8', labUltraReal: '1', labMaterialTruth: '1', labExactStorage: '1', labBbqVisual: '1', labCounterOneMesh: '1', labStableScenes: '1' };
    var next = url(), changed = false;
    Object.keys(defaults).forEach(function (key) {
      if (!next.searchParams.has(key)) { next.searchParams.set(key, defaults[key]); changed = true; }
    });
    if (changed) window.history.replaceState(window.history.state, '', next.toString());
  }
  function revealApp() {
    var app = byId('app');
    if (app && app.scrollIntoView) app.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
  function request(code, scroll) {
    if (!known(code)) {
      invalidEntry = true; save(active); setMode('showroom');
      message('That island link is no longer available. Choose one of the four models below.');
      return false;
    }
    invalidEntry = false; desired = code; entered = true;
    setMode('studio'); engineDefaults(); message('');
    waiters.splice(0).forEach(function (resolve) { resolve(code); });
    if (loader && (!active || codeOf(active) !== code)) loader(code);
    if (scroll) revealApp();
    return true;
  }
  function readLocation() {
    var current = url(), explicit = current.searchParams.get('model');
    if (current.searchParams.has('model') && !known(explicit)) return request(explicit, false);
    if (known(explicit)) return request(explicit, false);
    if (studioHash(current.hash)) return request(codeOf(active) || desired || MODELS[0], false);
    save(active); setMode('showroom'); return false;
  }
  function revision(instance) {
    var data = instance.opts.data;
    if (revisionCache.has(data)) return revisionCache.get(data);
    // Assembly caches options on block.__opts. A revision must not depend on which
    // trays were opened or caches populated before capture/restore.
    var blocks = (data.blocks || []).map(function (block) {
      return { key: block.key, id: block.id, widget: block.widget, sets: block.sets, letters: block.letters };
    });
    var sets = Object.keys(data.optionSets || {}).sort().map(function (key) {
      var set = data.optionSets[key];
      return { key: key, options: (set.options || []).map(function (option) {
        return { id: option.id, ord: option.ord, label: option.label, vc: option.vc };
      }) };
    });
    var text = JSON.stringify({ code: data.code, defaultCode: data.defaultCode, blocks: blocks, optionSets: sets });
    var hash = 2166136261;
    for (var i = 0; i < text.length; i++) { hash ^= text.charCodeAt(i); hash = Math.imul(hash, 16777619); }
    var result = (hash >>> 0).toString(16); revisionCache.set(data, result); return result;
  }
  function capture(instance) {
    var code = codeOf(instance);
    if (!known(code) || !instance.asm) return null;
    var selections = Object.create(null), labels = Object.create(null);
    (instance.opts.data.blocks || []).forEach(function (block) {
      if (!block.key) return;
      var value = instance.asm.state[block.key];
      if (typeof value === 'number' && Number.isFinite(value)) value = String(value);
      if (cleanString(value, 2000)) selections[block.key] = value;
    });
    FINISHES.forEach(function (key) {
      var option = instance.asm.selected(key);
      if (option && cleanString(option.label, 120)) labels[key] = option.label;
    });
    var grill = instance.asm.selected('GrillOptions');
    var sku = grill && instance.grillVariantSelection ? instance.grillVariantSelection(grill) : null;
    var scene = (instance.opts.scenes || [])[instance.sceneIndex];
    return { version: 1, modelCode: code, runtimeRevision: revision(instance), selections: selections,
      finishLabels: labels, grillSku: sku && cleanString(sku.sku, 160) ? sku.sku : null,
      sceneId: scene && cleanString(scene.id, 100) ? scene.id : null,
      positionTouched: !!instance._posTouched, updatedAt: new Date().toISOString() };
  }
  function save(instance) {
    if (!instance || instance._efiDetached || instance._efiRestoring || instance._efiNeedsReview) return false;
    var draft = capture(instance); if (!draft) return false;
    memory[draft.modelCode] = draft;
    try { window.sessionStorage.setItem(KEY + draft.modelCode, JSON.stringify(draft)); } catch (error) { /* In-page continuity still works. */ }
    return true;
  }
  function read(code) {
    if (!known(code)) return null;
    var draft = memory[code];
    if (!draft) {
      var raw;
      try { raw = window.sessionStorage.getItem(KEY + code); } catch (error) { return null; }
      if (!raw) return null;
      if (raw.length > 50000) return { unavailable: true };
      try { draft = JSON.parse(raw); } catch (error) { return { unavailable: true }; }
    }
    if (!isRecord(draft) || draft.version !== 1 || draft.modelCode !== code ||
        !isRecord(draft.selections) || Object.keys(draft.selections).length > 150) return { unavailable: true };
    return Object.assign({}, draft, { sceneId: cleanString(draft.sceneId, 100) ? draft.sceneId : null });
  }
  function begin(modelCode, previous, keepState) {
    if (!known(modelCode)) throw new Error('Unknown island model');
    var prior = capture(previous); save(previous);
    if (previous) previous._efiDetached = true;
    active = null; desired = modelCode;
    document.documentElement.setAttribute('data-efi-loading', 'true');
    var app = byId('app'); if (app) app.setAttribute('aria-busy', 'true');
    message('', previous || {});
    if (keepState && isRecord(keepState)) {
      return Object.assign({}, prior || {}, { version: 1, modelCode: modelCode,
        selections: Object.assign(Object.create(null), keepState), transfer: true });
    }
    return read(modelCode);
  }
  function restore(instance, draft) {
    instance._efiRestoring = true;
    instance._efiNeedsReview = false;
    instance._efiRestoreIssues = [];
    instance._efiRestoredValues = Object.create(null);
    if (!draft) return false;
    if (draft.unavailable) {
      instance._efiRestoreIssues.push('The earlier design could not be restored');
      return false;
    }
    if (!draft.transfer && draft.runtimeRevision !== revision(instance)) {
      instance._efiRestoreIssues.push('Available options have changed since this design was saved');
      return false;
    }
    var selections = draft.selections || {};
    Object.keys(selections).forEach(function (key) {
      var block = instance.asm.blockByKey.get(key), value = selections[key];
      if (!block) { if (value) instance._efiRestoreIssues.push(key); return; }
      if (typeof value === 'number' && Number.isFinite(value)) value = String(value);
      if (!cleanString(value, 2000)) { instance._efiRestoreIssues.push(block.label || key); return; }
      var options = instance.asm.optionsFor(key);
      if (options.length && !options.some(function (option) { return option.v === value; })) {
        if (value) instance._efiRestoreIssues.push(block.label || key); return;
      }
      // Optionless blocks hold customer text. Keep it as data, never HTML/URL markup.
      instance.asm.set(key, value); instance._efiRestoredValues[key] = value;
    });
    FINISHES.forEach(function (key) {
      var label = draft.finishLabels && draft.finishLabels[key];
      if (!cleanString(label, 120) || !instance.asm.blockByKey.has(key)) return;
      var same = function (a) { return String(a).toLowerCase().replace(/[^a-z]/g, ''); };
      var option = instance.asm.optionsFor(key).find(function (item) { return same(item.label) === same(label); });
      if (!option) { instance._efiRestoreIssues.push(key); return; }
      instance.asm.set(key, option.v); instance._efiRestoredValues[key] = option.v;
    });
    var grill = instance.asm.selected('GrillOptions');
    if (draft.grillSku && grill && instance.grillSkuVariants) {
      var variants = instance.grillSkuVariants(grill);
      if (variants.some(function (variant) { return variant.sku === draft.grillSku; })) {
        instance._grillSkuChoice[grill.v] = draft.grillSku;
      } else if (variants.length) instance._efiRestoreIssues.push('Grill fuel');
    }
    if (draft.positionTouched && instance.asm.blockByKey.has('GrillPosition')) instance._posTouched = true;
    return true;
  }
  function afterRestore(instance) {
    if (!instance._efiRestoreIssues) instance._efiRestoreIssues = [];
    Object.keys(instance._efiRestoredValues || {}).forEach(function (key) {
      if (instance.asm.state[key] === instance._efiRestoredValues[key]) return;
      if (instance.blockApplicable && !instance.blockApplicable(key)) return;
      var block = instance.asm.blockByKey.get(key);
      instance._efiRestoreIssues.push(block && block.label || key);
    });
    instance._efiRestoring = false;
    instance._efiNeedsReview = instance._efiRestoreIssues.length > 0;
  }
  function mountContact(instance) {
    var root = instance && instance.root;
    if (!root || !root.querySelector || root.querySelector('[data-efi-contact]')) return;
    var trust = root.querySelector('.efsk__brandrow');
    if (!trust || !trust.parentNode) return;
    var section = document.createElement('section');
    section.setAttribute('data-efi-contact', '');
    section.className = 'efi-build-contact';
    var titleId = 'efi-build-contact-title-' + codeOf(instance);
    section.setAttribute('aria-labelledby', titleId);
    var copy = document.createElement('div'); copy.className = 'efi-build-contact__copy';
    var title = document.createElement('h2'); title.id = titleId;
    title.className = 'efi-build-contact__title'; title.textContent = 'Questions about your build?';
    var description = document.createElement('p'); description.className = 'efi-build-contact__description';
    description.textContent = 'Talk through your layout, grill and finish with a specialist.';
    copy.appendChild(title); copy.appendChild(description);
    var actions = document.createElement('div'); actions.className = 'efi-build-contact__actions';
    var phone = document.createElement('a'); phone.className = 'efi-build-contact__link efi-build-contact__link--call';
    phone.href = 'tel:+19496197824'; phone.textContent = 'Call a specialist';
    var booking = document.createElement('a'); booking.className = 'efi-build-contact__link';
    booking.href = 'https://calendly.com/exceptionalfire/expert-consultation'; booking.textContent = 'Schedule a call';
    actions.appendChild(phone); actions.appendChild(booking);
    section.appendChild(copy); section.appendChild(actions);
    trust.parentNode.insertBefore(section, trust);
  }
  function committed(instance) {
    active = instance; instance._efiDetached = false; desired = codeOf(instance);
    mountContact(instance);
    document.documentElement.removeAttribute('data-efi-loading');
    var app = byId('app'); if (app) app.removeAttribute('aria-busy');
    if (document.documentElement.getAttribute('data-efi-mode') === 'studio') {
      var next = url(); next.searchParams.set('model', desired);
      window.history.replaceState(window.history.state, '', next.toString());
    }
    if (instance._efiNeedsReview) {
      var fields = Array.from(new Set(instance._efiRestoreIssues)).slice(0, 6).join(', ');
      message('Your earlier design needs a review: ' + fields + '. Check the current choices and updated price before continuing.', instance, true);
    } else { save(instance); message('', instance); }
  }
  function beforeCheckout(instance) {
    if (!instance || instance._efiRestoring || document.documentElement.hasAttribute('data-efi-loading')) return false;
    if (instance._efiNeedsReview) {
      var note = byId('efiStudioMessage'); if (note && note.scrollIntoView) note.scrollIntoView({ behavior: 'auto', block: 'center' });
      return false;
    }
    save(instance); return true;
  }
  function failed(error) {
    document.documentElement.removeAttribute('data-efi-loading');
    var app = byId('app');
    if (app) {
      app.removeAttribute('aria-busy'); app.replaceChildren();
      var copy = document.createElement('p'); copy.textContent = 'Your island could not load. Your saved design has been kept.';
      var retry = document.createElement('button'); retry.type = 'button'; retry.className = 'ef-b'; retry.textContent = 'Try again';
      retry.addEventListener('click', function () { window.location.reload(); });
      app.appendChild(copy); app.appendChild(retry);
    }
    console.error('[ef-island journey] startup failed', error);
  }
  window.EFIJourney = { known: known, request: request, applyEngineDefaults: engineDefaults,
    waitForStudio: function () { return entered ? Promise.resolve(desired) : new Promise(function (resolve) { waiters.push(resolve); }); },
    requestedModel: function () { return desired; }, setLoader: function (fn) { loader = fn; },
    capture: capture, save: save, read: read, begin: begin, restore: restore,
    afterRestore: afterRestore, committed: committed, beforeCheckout: beforeCheckout, failed: failed };
  window.addEventListener('ef:island:open', function (event) { request(event.detail && event.detail.modelCode, true); });
  window.addEventListener('hashchange', readLocation);
  window.addEventListener('popstate', readLocation);
  window.addEventListener('pagehide', function () { save(active); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') save(active); });
  // Fuel-only changes can redraw a tray without sync(), and free text may update on input.
  ['click', 'input', 'change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (!active || !event.target || !event.target.closest || !event.target.closest('#app')) return;
      window.clearTimeout(captureTimer); captureTimer = window.setTimeout(function () { save(active); }, 0);
    });
  });
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var destination; try { destination = new URL(link.href, window.location.href); } catch (error) { return; }
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !studioHash(destination.hash)) return;
    // Preserve native full navigation for real model links; only enhance old same-document anchors.
    if (destination.search !== window.location.search) return;
    var explicit = destination.searchParams.get('model');
    if (destination.searchParams.has('model') && !known(explicit)) return;
    request(explicit || codeOf(active) || desired || MODELS[0], false);
  });
  function ready() {
    if (invalidEntry) message('That island link is no longer available. Choose one of the four models below.');
    setMode(document.documentElement.getAttribute('data-efi-mode') || 'showroom');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  readLocation();
})(window, document);
